<template>
    <section class="content">
        <div class="container-fluid">
            <div class="card">
                <div class="card-header">
                    <h5 class="card-title">
                        Pengaturan Saldo Awal Unit Kerja
                    </h5>
                </div>

                <div class="card-body">
                    <div class="mb-3">
                        <button
                            class="btn btn-sm btn-success mr-2"
                            @click="centangSemua">
                            ✔ Centang Semua
                        </button>

                        <button
                            class="btn btn-sm btn-secondary mr-2"
                            @click="uncentangSemua">
                            ✖ Uncentang Semua
                        </button>

                        <button
                            class="btn btn-sm btn-primary float-right"
                            @click="simpan"
                            :disabled="loading">
                            💾 Simpan
                        </button>
                    </div>

                    <div class="table-responsive">
                        <table class="table table-bordered table-striped">
                            <thead class="thead-dark">
                                <tr>
                                    <th style="width:60px" class="text-center">No</th>
                                    <th>Nama Unit Kerja</th>
                                    <th style="width:120px" class="text-center">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(unit, index) in units" :key="unit.id">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ unit.nama }}</td>
                                    <td class="text-center">
                                        <input
                                            type="checkbox"
                                            v-model="unit.status_saldo_awal"
                                            true-value="Y"
                                            false-value="N"
                                        >
                                    </td>
                                </tr>

                                <tr v-if="units.length === 0">
                                    <td colspan="3" class="text-center text-muted">
                                        Data unit kerja tidak ditemukan
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
export default {
    //name: 'PengaturanSaldoAwal',

    data() {
        return {
            units: [],
            loading: false
        }
    },

    methods: {
        loadData() {
            axios.get('/api/saldo_awal')
                .then(res => {
                    this.units = res.data.data
                })
                .catch(() => {
                    toast.error('Gagal memuat data unit kerja')
                })
        },

        centangSemua() {
            this.units.forEach(u => {
                u.status_saldo_awal = 'Y'
            })
        },

        uncentangSemua() {
            this.units.forEach(u => {
                u.status_saldo_awal = 'N'
            })
        },

        simpan() {
            this.loading = true

            axios.post('/api/saldo_awal', {
                units: this.units
            })
            .then(() => {
                toast.success('Status saldo awal berhasil disimpan')
            })
            .catch(() => {
                toast.error('Gagal menyimpan status saldo awal')
            })
            .finally(() => {
                this.loading = false
            })
        }
    },

    mounted() {
        this.loadData()
    }
}
</script>

<style scoped>
.table td,
.table th {
    vertical-align: middle;
}
</style>
